import PostCodeInput from '../address/post-code-input';
import validation from '../address/input-validation';
import { FIELD_NAMES } from '../../constants';

const invoiceFields = [
  {
    name: FIELD_NAMES.firstName,
    label: 'dlv_user_firstname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.lastName,
    label: 'dlv_user_lastname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.companyName,
    label: 'dlv_user_companyname_required',
    required: true,
    extraValidations: [validation.inputLength(85)],
  },
  {
    name: FIELD_NAMES.streetName,
    label: 'dlv_user_streetname',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.city,
    label: 'dlv_user_city',
    required: true,
    extraValidations: [validation.inputLength(30)],
  },
  {
    name: FIELD_NAMES.countryCode,
    label: 'dlv_user_countryCode',
    required: true,
    isDropdown: true,
  },
  new PostCodeInput(),
  {
    name: FIELD_NAMES.vatNumber,
    label: 'dlv_user_vatnumber',
    required: true,
    pattern: '^[0-9]{10}$',
    patternMessage: 'dlv_validation_vatnumber',
    extraValidations: [validation.validateVat],
  },
];

const streetAndApartmentFieldsPrivate = [
  {
    name: FIELD_NAMES.streetNumber,
    label: 'dlv_user_streetnumber',
    required: true,
    extraValidations: [validation.inputLength(10)],
  },
  {
    name: FIELD_NAMES.apartmentNumber,
    label: 'dlv_user_apartmentnumber',
    required: false,
    extraValidations: [validation.inputLength(10)],
  },
];

const streetAndApartmentFieldsBusiness = [
  {
    name: FIELD_NAMES.streetNumber,
    label: 'dlv_user_street_number_business',
    required: true,
    extraValidations: [validation.inputLength(10)],
  },
  {
    name: FIELD_NAMES.apartmentNumber,
    label: 'dlv_user_apartment_number_business',
    required: false,
    extraValidations: [validation.inputLength(10)],
  },
];

const countryField = {
  input: FIELD_NAMES.countryCode,
  value: 'PL',
  valid: true,
};

const privateFieldNames = [
  FIELD_NAMES.firstName,
  FIELD_NAMES.lastName,
  FIELD_NAMES.streetName,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
  FIELD_NAMES.countryCode,
];

const businessFieldNames = [
  FIELD_NAMES.companyName,
  FIELD_NAMES.vatNumber,
  FIELD_NAMES.streetName,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
  FIELD_NAMES.countryCode,
];

const streetAndApartmentFieldNames = [FIELD_NAMES.streetNumber, FIELD_NAMES.apartmentNumber];
const allPrivateFieldNames = [...privateFieldNames];
allPrivateFieldNames.splice(3, 0, ...streetAndApartmentFieldNames);
const allBusinessFieldNames = [...businessFieldNames];
allBusinessFieldNames.splice(3, 0, ...streetAndApartmentFieldNames);

const allRequiredBusinessFields = [
  FIELD_NAMES.companyName,
  FIELD_NAMES.vatNumber,
  FIELD_NAMES.streetName,
  FIELD_NAMES.streetNumber,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
  FIELD_NAMES.countryCode,
];

const allRequiredPrivateFields = [
  FIELD_NAMES.firstName,
  FIELD_NAMES.lastName,
  FIELD_NAMES.streetName,
  FIELD_NAMES.streetNumber,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
  FIELD_NAMES.countryCode,
];

export const getFields = (fieldNames, insertIndex, buildingAndApartmentFields) => {
  const fields = fieldNames.reduce((acc, fieldName) => {
    const field = invoiceFields.find(f => f.name === fieldName);
    return field ? [...acc, field] : acc;
  }, []);
  fields.splice(insertIndex, 0, buildingAndApartmentFields);
  return fields;
};

const privateUserFields = getFields(privateFieldNames, 3, streetAndApartmentFieldsPrivate);
const businessUserFields = getFields(businessFieldNames, 3, streetAndApartmentFieldsBusiness);

const pocztaBusinessFields = [
  FIELD_NAMES.streetName,
  FIELD_NAMES.streetNumber,
  FIELD_NAMES.apartmentNumber,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
];
const inpostAndRuchPrivateFields = [FIELD_NAMES.firstName, FIELD_NAMES.lastName];
const pocztaPrivateFields = [
  FIELD_NAMES.firstName,
  FIELD_NAMES.lastName,
  FIELD_NAMES.streetName,
  FIELD_NAMES.streetNumber,
  FIELD_NAMES.apartmentNumber,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
];
const sellerConfirmationBusinessFields = [
  FIELD_NAMES.streetName,
  FIELD_NAMES.streetNumber,
  FIELD_NAMES.apartmentNumber,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
];
const sellerConfirmationPrivateFields = [
  FIELD_NAMES.firstName,
  FIELD_NAMES.lastName,
  FIELD_NAMES.streetName,
  FIELD_NAMES.streetNumber,
  FIELD_NAMES.apartmentNumber,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
];
const confirmationHiddenBusinessFields = [
  FIELD_NAMES.streetName,
  FIELD_NAMES.streetNumber,
  FIELD_NAMES.apartmentNumber,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
  FIELD_NAMES.countryCode,
];
const confirmationHiddenPrivateFields = [
  FIELD_NAMES.firstName,
  FIELD_NAMES.lastName,
  FIELD_NAMES.streetName,
  FIELD_NAMES.streetNumber,
  FIELD_NAMES.apartmentNumber,
  FIELD_NAMES.postCode,
  FIELD_NAMES.city,
  FIELD_NAMES.countryCode,
];

export default {
  privateFieldNames,
  businessFieldNames,
  streetAndApartmentFieldNames,
  allPrivateFieldNames,
  allBusinessFieldNames,
  allRequiredBusinessFields,
  allRequiredPrivateFields,
  privateUserFields,
  businessUserFields,
  invoiceFields,
  countryField,
  streetAndApartmentFieldsPrivate,
  streetAndApartmentFieldsBusiness,
  pocztaBusinessFields,
  inpostAndRuchPrivateFields,
  pocztaPrivateFields,
  sellerConfirmationBusinessFields,
  sellerConfirmationPrivateFields,
  confirmationHiddenBusinessFields,
  confirmationHiddenPrivateFields,
};
